<template>
	<div class="index">
			<div class="useri_right_pad">
				<div class="userirp_d1"><span></span>我的订单</div>
				<el-tabs class="type" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="全部订单" name="0"></el-tab-pane>
					<el-tab-pane label="待付款" name="1"></el-tab-pane>
					<el-tab-pane label="待发货" name="2"></el-tab-pane>
					<el-tab-pane label="待收货" name="3"></el-tab-pane>
					<el-tab-pane label="已完成" name="4"></el-tab-pane>
				</el-tabs>
				<div v-if="device !== 'mobile'">
            	<div v-if="order_list.length > 0" >
                	<div class="mor_b3">
						<div class="mor_b3_tit">
							<span class="mor_b3_tit_sp1">商品信息</span>
							<span class="mor_b3_tit_sp2">单价</span>
							<span class="mor_b3_tit_sp3">数量</span>
							<span class="mor_b3_tit_sp4">实付款</span>
							<span class="mor_b3_tit_sp5">交易状态</span>
							<span class="mor_b3_tit_sp6">交易操作</span>
						</div>
					</div>
					<div class="mor_b4" @scroll="handleScroll">
						<div class="mor_b4_pad" v-for="(item, index) in order_list" :key="index" > 
							<!-- for -->
							<div class="mor_b4_pad_tit">
							<div class="mor_b4_pad_tit_d1">
								<span>{{item.AddTime}}</span>
								<span>订单号：{{ item.OrderNo }}</span>
							</div>
							<div class="mor_b4_pad_img2" @click="orderDel(item.OrderNo)">
								<img src="del.png" />删除
							</div>
							</div>
							<div class="mor_b4_pad_body">
							<div class="morb4pb_d1" >
								<div class="morb4pb_d1_d1" v-for="product in item.order_goods" :key="product.id" >
									<div class="morb4pb_d1_d1_pad" >
										<img class="morb4pb_d1_d1_img1" :src="imgUrl+product.ProductImg">
										<div class="morb4pb_d1_d1_d2">
											<span class="morb4pb_d1_d1_d2_sp1">{{product.ProductName}}</span>
										</div>
										<div class="morb4pb_d1_d2">
											￥{{product.Price}}
										</div>
										<div class="morb4pb_d1_d3">
											{{ product.Count }}
										</div>
									</div>
								</div>
							</div>
							<div class="morb4pb_d2">
								<span>￥{{ item.OrderPrice }}</span>
							</div>
							<div class="morb4pb_d3">
								<span v-if="item.OrderState == 1">待付款</span>
      							<span v-if="item.OrderState == 2">待发货</span>
    							<span v-if="item.OrderState == 3">待收货</span>
    							<span v-if="item.OrderState == 4">已完成</span>
    							<span v-if="item.OrderState == 5">已取消</span>
								<!-- <a class="morb4pb_d3_a" @click="tobuy(item.OrderNo)">订单详情</a> -->
							</div>
							<div class="morb4pb_d4" v-if="item.OrderState == 1" >
								<button @click="tobuy(item.OrderNo)" >立即支付</button>
								<a @click="CancelOrder(item.OrderNo)">取消订单</a>
							</div>
							<div class="morb4pb_d4" v-if="item.OrderState == 2" >
								<button @click="ReturnOrder(item.OrderNo)" >申请退款</button>
							</div>
							<div class="morb4pb_d4" v-if="item.OrderState == 3" >
								<button @click="ConfirmOrders(item.OrderNo)" >确认收货</button>
							</div>
							</div>
						</div>
						<div class='loading' v-if="isLoading">Loading...</div>
						<div class='loading' v-if="!hasMoreData">已加载所有数据</div>
					</div>
				</div> 
				<div v-else>
					<div class="wushuju">
						<img src=""/>
						没有数据
					</div>
            	</div>
				</div>
				<div class="mor_b4" @scroll="handleScroll" v-else>
                	<div class="order_body" v-for="(item, index) in order_list" :key="index">
    				    <div class="order_body_d1" >
    				        <div class="order_body_d1_l" >
    				            <span style="color: #999;">订单号：</span>
    				            {{ item.OrderNo }}
    				        </div>
    				        <div class="order_body_d1_r">
    				            <el-button
    				                plain
    				                type="default"
    				                size="small"
    				                @click="orderDel(item.OrderNo)"
    				            >删除</el-button>
    				        </div>
    				    </div>
    				    <div class="order_body_d2" v-for="product in item.order_goods" :key="product.id">
    				        <img :src="imgUrl+product.ProductImg"/>
    				        <div class="order_body_d2_d1">
    				            <span class="order_body_d2_sp1">{{product.ProductName}}</span>
    				            <span class="order_body_d2_sp2">价格：￥{{product.Price}}</span>
    				        </div>
    				        <div class="order_body_d2_d3">×{{ product.Count }}</div>
    				    </div>
    				    <div class="order_body_d3">
    				        <span v-if="item.OrderState == 1">待付款</span>
    				  		<span v-if="item.OrderState == 2">待发货</span>
    						<span v-if="item.OrderState == 3">待收货</span>
    						<span v-if="item.OrderState == 4">已完成</span>
    						<span v-if="item.OrderState == 5">已取消</span>
    				        <span class="order_body_d3_sp2" v-if="item.OrderState == 1">价格：￥{{item.OrderQZPrice}}元</span>
    				    </div>
    				    <div class="order_body_d4">
    				        <el-button
    				            plain
    				            type="default"
    				            size="small"
    				            class="order_body_d4_b"
    				            @click="tobuy(item.OrderNo)"
    				        >订单详情</el-button>
    				        <el-button
								v-if="item.OrderState != 5"
    				            plain
    				            type="default"
    				            size="small"
    				            class="order_body_d4_b"
    				            @click="CancelOrder(item.OrderNo)"
    				        >取消订单</el-button>
    				        <el-button 
								v-if="item.OrderState == 1"
    				            type="danger"
    				            size="small"
    				            class="order_body_d4_b"
								@click="tobuy(item.OrderNo)"
    				        >继续支付</el-button>
							<el-button 
								v-if="item.OrderState == 3 || item.OrderState == 2"
    				            type="danger"
    				            size="small"
    				            class="order_body_d4_b"
								@click="ConfirmOrders(item.OrderNo)"
    				        >确认收货</el-button>
    				    </div>
    				</div>
					<div class='loading' v-if="isLoading">Loading...</div>
					<div class='loading' v-if="!hasMoreData">已加载所有数据</div>
            	</div>
            </div>
		</div>
</template>


<script>
import { VUE_APP_IMG_URL } from "@/config";
import { mapGetters } from "vuex"
import Order from "@/components/Order"
	export default {
        components:{
            Order
        },
		data() {
			return {
				imgUrl: "",
				OrderNo:'',
				activeName: '0',
				state:'0',
				order_list:[],
				cont:'',
				page:1,
				isLoading:false,
				hasMoreData:true,
			}
		},
		computed: {
            ...mapGetters(["device"])
		},
		watch: {

		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL;
		},
		mounted: function() {
			window.addEventListener('scroll', this.handleScroll);
			this.get_Order();
			// this.getMyOrderState();
		},
		methods: {
			handleScroll() {
  			  if (!this.isLoading && this.hasMoreData) {
    			  const container = document.querySelector('.mor_b4');
    			  const scrollHeight = container.scrollHeight;
    			  const offsetHeight = container.offsetHeight;
    			  const scrollTop = container.scrollTop;
    			  if (scrollHeight - scrollTop - offsetHeight <= 50) {
    			    this.loadMoreData();
    			  }
    			}
  			},
  			 loadMoreData() {
  			  this.isLoading = true;
  			  setTimeout(async () => {
  			    let res =  await this.$post("get_Order",{state: this.state ,page:this.page}) 
				const newData = res.data.ResultData;
				console.log(newData,'newData');
  			    this.order_list = [...this.order_list, ...newData];
				console.log(this.order_list,'this.order_list');
				this.order_list.forEach((list) => {
					list.AddTime = Number(list.AddTime.match(/\d+/)[0]);
					list.AddTime = new Date(list.AddTime);
					const year = list.AddTime.getFullYear().toString();
  					const month = (list.AddTime.getMonth() + 1).toString().padStart(2, '0');
  					const day = list.AddTime.getDate().toString().padStart(2, '0');
  					list.AddTime = `${year}-${month}-${day}`;
      			});
  			    this.page += 1;
				if(newData.length<10){
					this.hasMoreData = false;
				}
  			    this.isLoading = false; 
  			  }, 1000); 
  			},
			handleClick(tab){
    			const tabIndex = tab.name;
				this.state = tabIndex;
				this.hasMoreData = true;
				// this.order_list=[];
				this.get_Order();
			},
			async orderDel(e) {
				await this.$confirm("你是否要删除该条订单数据?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
				this.getOrderDel();
    		},
    		async CancelOrder(e) {
    		    await this.$confirm("你是否要取消该条订单数据?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getCancelOrder();
    		},
			async ConfirmOrders(e){
				await this.$confirm("你是否确认收到货品?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getConfirmOrders();
			},
			async ReturnOrder(){
				await this.$confirm("你是否要退货?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getReturnOrder();
			},
			async get_Order() {
        		var res = await this.$post("get_Order",{state: this.state})
        		console.log(res, '获取订单');
           		this.order_list= res.data.ResultData
				this.cont = res.data.RowCount
				this.order_list.forEach((list) => {
					list.AddTime = Number(list.AddTime.match(/\d+/)[0]);
					list.AddTime = new Date(list.AddTime);
					const year = list.AddTime.getFullYear().toString();
  					const month = (list.AddTime.getMonth() + 1).toString().padStart(2, '0');
  					const day = list.AddTime.getDate().toString().padStart(2, '0');
  					list.AddTime = `${year}-${month}-${day}`;
      			});
				if(this.order_list.length<10){
					this.hasMoreData = false;
				}
    		},
			async getOrderDel() {
    		    var res = await this.$post("orderDel",{OrderNo: this.OrderNo})
    		    console.log(res, '删除订单');
    		    this.get_Order()
    		},
    		async getCancelOrder(){
    		    var res = await this.$post("CancelOrder",{OrderNo: this.OrderNo})
    		    console.log(res, '取消订单');
    		    this.get_Order()
    		},
    		async getConfirmOrders(){
    		    var res = await this.$post("ConfirmOrders",{OrderNo: this.OrderNo})
    		    console.log(res, '确认收货');
    		    this.get_Order()
    		},
			async getReturnOrder(){
    		    var res = await this.$post("ConfirmOrders",{OrderNo: this.OrderNo})
    		    console.log(res, '退货');
    		    this.get_Order()
    		},
			tobuy(e) {
      			this.$router.push({
        			path: "/buy",
        			query: {
          				OrderNo: e,
        			},
      			});
    		},
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList() {
				this.$router.push("/orderList")
			},
			toFast() {
				this.$router.push("/fast")
			},
			toSetPwd() {
				this.$router.push("/setPwd")
			},
			toUserInfo() {
				this.$router.push("/userInfo")
			},
			toCar() {
				this.$router.push("/car")
			}
		}
	}
</script>

<style >
@media (max-width: 992px) {
  .msgbox{
    width: 320px !important;
  }
}
</style>
<style scoped >
.index{
padding: 18px 0 0;
box-sizing: border-box;
border: 1px solid #dedede;
width: 83%;
}
.useri_right_pad{
	width: 100%;
    margin: 0 auto;
}
.useri{
	width: 1200px;
}
.type{
	margin-left: 10px;
}
.mor_b3_tit{
	width: 971px;
	margin-left: 7px;
	box-sizing: border-box;
	border:1px solid #dddddd;
	background-color: #f5f5f5;
	color: #333333;
	font-size: 14px;
	height: 40px;
	display: flex;
	flex-direction: row;
	
}

.mor_b3_tit span{
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.mor_b3_tit_sp1{
	width: 320px;
}
.mor_b3_tit_sp2{
	width: 120px;
}
.mor_b3_tit_sp3{
	width: 120px;
}
.mor_b3_tit_sp4{
	width: 130px;
}
.mor_b3_tit_sp5{
	width: 140px;
}
.mor_b3_tit_sp6{
	width: 141px;
}

.mor_b4{
	padding-bottom: 20px;
	max-height: 500px;
	overflow-y: auto;

}

.mor_b4_pad{
	width: 971px;
	
	margin-left: 7px;
	margin-top: 14px;
	box-sizing: border-box;
	border:1px solid #dddddd;

}

.mor_b4_pad_tit{
	width: 100%;
	height: 40px;
	box-sizing: border-box;
	border-bottom:1px solid #dddddd;
	background-color: #f3f3f3;
	color: #333;
	font-size: 13px;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.mor_b4_pad_tit_d1{
	width: 90%;
	margin-left: 20px;
	display: flex;
	flex: 1;
	align-items: center;
}
.loading{
	text-align: center;
}
.mor_b4_pad_img2{
	cursor:pointer;
	margin-right: 20px;
	display: flex;
	align-items: center;
	font-size:14px ;
}
.mor_b4_pad_img2 img{
	width: 16px;
	height:16px;
	margin-right: 2px;
}

.mor_b4_pad_tit span{
	padding: 0 20px;
	height: 100%;
	line-height: 40px;
}

.mor_b4_pad_tit span:nth-child(3){
	font-weight: 600;
}

.mor_b4_pad_body{
	width: 100%;
	display: flex;
	flex-direction: row;
}

.morb4pb_d1{
	width: 560px;
	flex-direction: row;
}

.morb4pb_d2{
	width: 130px;
	box-sizing: border-box;
	border-left:1px solid #dddddd;
	border-right:1px solid #dddddd;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: #ff0000;
	font-size: 15px;
}
.morb4pb_d2 span{
	margin-top: 20px;
}
.morb4pb_d3{
	width: 140px;
	box-sizing: border-box;
	border-right:1px solid #dddddd;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: #333;
	font-size: 15px;
}
.morb4pb_d3 span{
	margin-top: 20px;
}
.morb4pb_d3_a{
	color: #58bad8;
	margin-top: 6px;
}
.morb4pb_d4{
	width: 141px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 14px;
}

.morb4pb_d4 button{
	margin: 20px 0 0 0;
	padding: 0;
	border: 0px;
	width: 68px;
	height: 26px;
	border-radius: 4px;
	background-color: #61caea;
	color: white;
	margin-bottom: 10px;
}

.morb4pb_d1_d1{
	width: 560px;
	display: flex;
	flex-direction: column;
}



.morb4pb_d1_d1_pad{
	width: 100%;
	display: flex;
	flex-direction: row;
	padding: 20px 0;
	box-sizing: border-box;
	border-top:1px solid #dddddd;
}
.morb4pb_d1_d1 .morb4pb_d1_d1_pad:nth-child(1){
	border-top:0px;
}
.morb4pb_d1_d1_img1{
	width: 70px;
	height: 70px;
	margin: 0 10px 0 20px;
}

.morb4pb_d1_d1_d2{
	width: 218px;
	display: flex;
	flex-direction: column;
	font-size: 14px;
	color: #333;
	justify-content: center;
}

.morb4pb_d1_d2{
	width: 120px;
	font-size: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.morb4pb_d1_d3{
	width: 120px;
	font-size: 15px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.wushuju{
	text-align: center;
	margin-top: 50px;
}
.userirp_d1{
	margin-bottom: 10px;
}
.userirp_d1 span{
	background-color: #2b2b2b;
}
.order_body {
		background-color: white;
		padding-left: calc(20px/2);
		padding-right: 10px;
		margin: 13px auto;
		color: #333;
	}
.order_body_d1 {
		width: 100%;
		height: calc(82px/2);
	}

	.order_body_d1 {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.order_body_d1_l {
		width: 50%;
		line-height: calc(28px/2);
		font-size: calc(28px/2);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		white-space: nowrap;
	}

	.order_body_d1_r {
		width: 50%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.order_body_d1_r_d {
		width: calc(60px/2);
		height: calc(50px/2);
		color: #666;
	}

	.order_body_d2 {
		width: 100%;
		height: calc(190px/2);
		display: flex;
		flex-direction: row;
		align-items: center;
		box-sizing: border-box;
		border-top: calc(2px/2) solid #f2f2f2;
		border-bottom: calc(2px/2) solid #f2f2f2;
	}

	.order_body_d2 img {
		width: calc(150px/2);
		height: calc(150px/2);
		border-radius: calc(10px/2);
		margin-right: calc(20px/2)
	}

	.order_body_d2_d1 {
		width: calc(500px/2);
		font-size: calc(30px/2);
		height: calc(150px/2);
		display: flex;
		flex-direction: column;
		text-align: left;
		justify-content: flex-start;
		line-height: calc(54px/2);
	}

	.order_body_d2_d3 {
		font-size: calc(28px/2);
	}

	.order_body_d3 {
		width: 100%;
		height: calc(80px/2);
		display: flex;
		align-items: center;
		font-size: calc(28px/2);
	}

	.order_body_d3_sp1 {
		width: 20%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: red;
	}

	.order_body_d3_sp2 {
		width: 80%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.order_body_d4 {
		box-sizing: border-box;
		border-top: calc(2px/2) solid #f2f2f2;
		width: 100%;
		height: calc(100px/2);
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.order_body_d4_b {
		margin-left: calc(30px/2);
		height: calc(64px/2);
	}
</style>

<style lang="scss" scoped src="./mobile.scss" ></style>